import type React from 'react';
import styles from './ProductModal.module.scss';
import Picture from '../../../general/Picture/Picture';
import { useIsMobile } from '../../../general/hooks/useSize';
import Source from '../../../general/Picture/Source';
import type { CartItem } from '../../Store/CartItem/state';
import { useIsInitialRequestMobile } from '../../../general/WebshopContext/WebshopContext';

interface ProductModalProps {
    onClose: () => void;
    product: Pick<CartItem, 'name' | 'previewImage'>;
}

const ProductModal: React.FC<ProductModalProps> = ({ onClose, product }) => {
    const isMobileOrTablet = useIsMobile(useIsInitialRequestMobile());

    return (
        <div
            className="fancybox-wrap fancybox-desktop fancybox-type-html fancybox-opened"
            style={{
                display: 'block',
                height: 'max-content',
                inset: '0',
                margin: 'auto',
                maxHeight: isMobileOrTablet ? '100%' : '600px',
                maxWidth: isMobileOrTablet ? '100%' : '600px',
                opacity: 1,
                overflow: 'visible',
                position: 'absolute',
                width: isMobileOrTablet ? 'max-content' : '600px',
            }}
        >
            <div className="fancybox-skin">
                <div className="fancybox-outer">
                    <div className="fancybox-inner" style={{ display: 'block' }} >
                        <div>
                            <div className={styles.ProductModal__picture}>
                                <Picture imageClass={styles.ProductModal__image} imageUrl={product.previewImage} alt={product.name}>
                                    <Source imageWidth={600} minScreenWidth={600} />
                                    <Source imageWidth={360} />
                                </Picture>
                            </div>
                        </div>
                    </div>
                </div>
                <button onClick={onClose} className="fancybox-item fancybox-close" type="button" aria-label="Close modal" />
            </div>
        </div>
    );
};

export default ProductModal;
